export default class movie {
  constructor() {
    this.movieAction();
  }

  movieAction() {
    const $ytPlayer = document.querySelectorAll('.js-yt-player');
    const $movieModalBtn = document.querySelectorAll('.js-movieBtn');

    if ($movieModalBtn.length || $ytPlayer.length) {

      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = function () {

        if ($ytPlayer.length) {
          $ytPlayer.forEach(elm => {

            const ytFrame = elm.querySelector('.js-yt-frame');
            const datas = elm.dataset;
            const dataId = datas.ytId;
            const dataWidth = datas.ytWidth;
            const dataHeight = datas.ytHeight;
            const dataAutoplay = datas.ytAutoplay === 'true' ? 1 : 0;
            const dataControls = datas.ytControls === 'false' ? 0 : 1;
            const dataFs = datas.ytFs === 'false' ? 0 : 1;
            const dataLoop = datas.ytLoop === 'true' ? 1 : 0;

            // eslint-disable-next-line no-unused-vars
            const ytPlay = new YT.Player(ytFrame, {
              width: dataWidth,
              height: dataHeight,
              videoId: dataId,

              playerVars: {
                autoplay: dataAutoplay,
                controls: dataControls,
                fs: dataFs,
                loop: dataLoop,
                rel: 0,
                origin: location.protocol + '//' + location.hostname + '/'
              },
              events: {
                onReady: onPlayerReady
              }
            });

            function onPlayerReady(e) {
              if (dataAutoplay) {
                e.target.mute();
                e.target.playVideo();
              }
            }
          });
        }

      };
    }
  }
}
